import React from 'react';
import { View, Text, FlatList } from 'react-native';
import { tw } from '../../utils/tailwind';
import { usePrintersQueries } from '../../api/hooks/vendor/printers/use-printers-queries';
import { useT } from '../../utils/helper';
import { useGroupedBluetoothPrinters } from '../../hooks/use-grouped-bluetooth-printer';
import {
  PrinterModel,
  PrinterModelType,
} from '../../api/types/vendor/printers.type';

export const PrinterTable = () => {
  // Hooks
  const t = useT();
  const tScreen = useT('screens', { keyPrefix: 'PrinterList' });
  const { fetchPrinters } = usePrintersQueries();
  const groupedPrinters = useGroupedBluetoothPrinters();

  const getConnectedPrinterNames = (model: PrinterModelType): string => {
    switch (model) {
      case PrinterModel.STAR_BLUETOOTH:
      case PrinterModel.EPSON_BLUETOOTH:
        return groupedPrinters
          .findByModel(model)
          .map(printer => printer.deviceName)
          .join(', ');
      case PrinterModel.SUNMI_BLUETOOTH:
      default:
        return '';
    }
  };

  return (
    <View style={tw`flex bg-white px-1 pt-1 rounded-lg`}>
      {/* Header Row */}
      <View
        style={tw`flex gap-x-1 flex-row py-2 px-4 border-b border-gray-200`}>
        <Text style={tw`flex-0.2 text-center font-bold`} />
        <Text style={tw`flex-2 text-left font-bold`}>
          {tScreen('printerModel')}
        </Text>
        <Text style={tw`flex-0.6 text-center font-bold`}>
          {tScreen('enabled')}
        </Text>
        <Text style={tw`flex-2 text-center font-bold`}>
          {tScreen('connectedPrinters')}
        </Text>
      </View>

      {/* Data Rows */}
      <FlatList
        data={fetchPrinters.data?.printers || []}
        refreshing={fetchPrinters.isFetching}
        onRefresh={fetchPrinters.refetch}
        keyExtractor={item => item.id.toString()}
        renderItem={({ item, index }) => (
          <View
            style={tw`flex gap-x-1 flex-row py-2 px-4 border-b border-gray-200`}>
            <Text style={tw`flex-0.2`}>{index + 1}.</Text>
            <Text style={tw`flex-2 text-left`}>{item.human_printer_model}</Text>
            <Text style={tw`flex-0.6 text-center`}>
              {t(item.enabled.toString())}
            </Text>
            <Text style={tw`flex-2 text-center`}>
              {getConnectedPrinterNames(item.printer_model)}
            </Text>
          </View>
        )}
      />
    </View>
  );
};
